import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = {
  key: 1,
  class: "container"
}
const _hoisted_7 = { class: "fg-color-blue" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-info ml-2"
}
const _hoisted_9 = {
  key: 0,
  class: "alert alert-info mt-3",
  role: "alert"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "col-sm-6 mb-4"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "card-text",
  style: {"height":"170px"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "card-footer text-center" }
const _hoisted_20 = {
  key: 1,
  class: "col-sm-6 mb-4"
}
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = {
  class: "card-text",
  style: {"height":"170px"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "card-footer text-center" }
const _hoisted_29 = {
  key: 2,
  class: "col-sm-6 mb-4"
}
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = {
  class: "card-text",
  style: {"height":"170px"}
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "card-footer text-center" }
const _hoisted_36 = {
  key: 3,
  class: "col-sm-6 mb-4"
}
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = {
  class: "card-text",
  style: {"height":"170px"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "card-footer text-center" }
const _hoisted_43 = {
  key: 2,
  class: "container"
}
const _hoisted_44 = { class: "input-group mb-3" }
const _hoisted_45 = {
  key: 3,
  class: "container"
}

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    import
        {
            useCurrentUserQueryV1,
            useUserQueryV1
        } from '@Organizations/Users/queries-vue-composables'

    import
        {
            useAssignGlobalAdminRoleCommandV1,
            useRevokeGlobalAdminRoleCommandV1,
            useAssignOrganizationAdminRoleCommandV1,
            useRevokeOrganizationAdminRoleCommandV1,
            useAssignWorkspaceUserRoleCommandV1,
            useRevokeWorkspaceUserRoleCommandV1,
            useAssignBusinessUserRoleCommandV1,
            useRevokeBusinessUserRoleCommandV1
        } from '@Organizations/Users/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserRolesPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const id = computed(() =>
        typeof route.params.id === 'string'
            ? route.params.id
            : null
    )

    // ---------------- local state ----------------

    const emailinput = ref('')

    // ---------------- queries ----------------

    // current (logged-in) user
    const {
        modelCurrentUserQueryV1: userSessionDetails,
        runCurrentUserQueryV1
    } = useCurrentUserQueryV1(false, false, true)

    // managed user (ID is bound here)
    const {
        modelUserQueryV1: user,
        runUserQueryV1
    } = useUserQueryV1(id)

    // ---------------- commands (ID bound in use) ----------------

    const {
        invokeAssignGlobalAdminRoleCommandV1,
        onSucceedAssignGlobalAdminRoleCommandV1
    } = useAssignGlobalAdminRoleCommandV1(id)

    const {
        invokeRevokeGlobalAdminRoleCommandV1,
        onSucceedRevokeGlobalAdminRoleCommandV1
    } = useRevokeGlobalAdminRoleCommandV1(id)

    const {
        invokeAssignOrganizationAdminRoleCommandV1,
        onSucceedAssignOrganizationAdminRoleCommandV1
    } = useAssignOrganizationAdminRoleCommandV1(id)

    const {
        invokeRevokeOrganizationAdminRoleCommandV1,
        onSucceedRevokeOrganizationAdminRoleCommandV1
    } = useRevokeOrganizationAdminRoleCommandV1(id)

    const {
        invokeAssignWorkspaceUserRoleCommandV1,
        onSucceedAssignWorkspaceUserRoleCommandV1
    } = useAssignWorkspaceUserRoleCommandV1(id)

    const {
        invokeRevokeWorkspaceUserRoleCommandV1,
        onSucceedRevokeWorkspaceUserRoleCommandV1
    } = useRevokeWorkspaceUserRoleCommandV1(id)

    const {
        invokeAssignBusinessUserRoleCommandV1,
        onSucceedAssignBusinessUserRoleCommandV1
    } = useAssignBusinessUserRoleCommandV1(id)

    const {
        invokeRevokeBusinessUserRoleCommandV1,
        onSucceedRevokeBusinessUserRoleCommandV1
    } = useRevokeBusinessUserRoleCommandV1(id)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = "Manage user's roles"
        runCurrentUserQueryV1()
    })

    // ---------------- react to route param ----------------

    watch(id, (newId) =>
    {
        if (newId)
            runUserQueryV1()
    }, { immediate: true })

    // ---------------- refresh after ANY role change ----------------

    function refreshUser()
    {
        if (id.value)
            runUserQueryV1()
    }

    onSucceedAssignGlobalAdminRoleCommandV1(refreshUser)
    onSucceedRevokeGlobalAdminRoleCommandV1(refreshUser)
    onSucceedAssignOrganizationAdminRoleCommandV1(refreshUser)
    onSucceedRevokeOrganizationAdminRoleCommandV1(refreshUser)
    onSucceedAssignWorkspaceUserRoleCommandV1(refreshUser)
    onSucceedRevokeWorkspaceUserRoleCommandV1(refreshUser)
    onSucceedAssignBusinessUserRoleCommandV1(refreshUser)
    onSucceedRevokeBusinessUserRoleCommandV1(refreshUser)

    // ---------------- derived: current user ----------------

    const currentUserOrganizationUnitId = computed(() =>
        userSessionDetails.value?.OrganizationUnitId
    )

    const currentUserIsSystemAdmin = computed(() =>
        userSessionDetails.value?.IsSystemAdmin ?? false
    )

    const currentUserIsGlobalAdmin = computed(() =>
        userSessionDetails.value?.IsGlobalAdmin ?? false
    )

    const currentUserIsOrganizationAdmin = computed(() =>
        userSessionDetails.value?.IsOrganizationAdmin ?? false
    )

    // ---------------- derived: managed user ----------------

    const email = computed(() => user.value?.Email)
    const displayName = computed(() => user.value?.DisplayName)

    const isSystemAdmin = computed(() => user.value?.IsSystemAdmin)
    const isGlobalAdmin = computed(() => user.value?.IsGlobalAdmin)
    const isOrganizationAdmin = computed(() => user.value?.IsOrganizationAdmin)
    const isWorkspaceUser = computed(() => user.value?.IsWorkspaceUser)
    const isBusinessUser = computed(() => user.value?.IsBusinessUser)
    const isServiceUser = computed(() => user.value?.IsServiceUser ?? false)

    const organizationUnitId = computed(() =>
        user.value?.OrganizationUnitId
    )

    // ---------------- derived: roles label ----------------

    const roles = computed(() =>
    {
        const r: string[] = []

        if (isSystemAdmin.value) r.push('System Admin')
        if (isGlobalAdmin.value) r.push('Global Admin')
        if (isOrganizationAdmin.value) r.push('Organization Admin')
        if (isWorkspaceUser.value) r.push('Workspace User')
        if (isBusinessUser.value) r.push('Business User')
        if (isServiceUser.value) r.push('Service Account')

        return r
    })

    // ---------------- helpers ----------------

    function confirmAction(action: string)
    {
        const accountType = isServiceUser.value ? 'service account' : 'user'
        return confirm(`Do you really want to ${action} for ${accountType} ${email.value}?`)
    }

    // ---------------- handlers ----------------

    function handleAssignGlobalAdminRoleCommandV1()
    {
        if (confirmAction('assign Global Admin role'))
            invokeAssignGlobalAdminRoleCommandV1()
    }

    function handleRevokeGlobalAdminRoleCommandV1()
    {
        if (confirmAction('revoke Global Admin role'))
            invokeRevokeGlobalAdminRoleCommandV1()
    }

    function handleAssignOrganizationAdminRoleCommandV1()
    {
        if (confirmAction('assign Organization Admin role'))
            invokeAssignOrganizationAdminRoleCommandV1()
    }

    function handleRevokeOrganizationAdminRoleCommandV1()
    {
        if (confirmAction('revoke Organization Admin role'))
            invokeRevokeOrganizationAdminRoleCommandV1()
    }

    function handleAssignWorkspaceUserRoleCommandV1()
    {
        if (confirmAction('assign Workspace User role'))
            invokeAssignWorkspaceUserRoleCommandV1()
    }

    function handleRevokeWorkspaceUserRoleCommandV1()
    {
        if (confirmAction('revoke Workspace User role'))
            invokeRevokeWorkspaceUserRoleCommandV1()
    }

    function handleAssignBusinessUserRoleCommandV1()
    {
        if (confirmAction('assign Business User role'))
            invokeAssignBusinessUserRoleCommandV1()
    }

    function handleRevokeBusinessUserRoleCommandV1()
    {
        if (confirmAction('revoke Business User role'))
            invokeRevokeBusinessUserRoleCommandV1()
    }

    function handleFindUser()
    {
        if (!emailinput.value) return

        router.push(
            `/admin/organizations/users/manage/roles/${encodeURIComponent(emailinput.value)}`
        )
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (currentUserIsOrganizationAdmin.value && currentUserOrganizationUnitId.value == organizationUnitId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (organizationUnitId.value)
            ? (_openBlock(), _createBlock(AdminNavigationV2, {
                key: 0,
                tid: organizationUnitId.value
              }, null, 8 /* PROPS */, ["tid"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(isServiceUser.value ? "Manage service account's roles" : "Manage user's roles"), 1 /* TEXT */),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))])
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    (id.value && _unref(user))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h4", _hoisted_7, [
            _createTextVNode(_toDisplayString(displayName.value) + " is currently " + _toDisplayString(roles.value.join(', ')) + " ", 1 /* TEXT */),
            (isServiceUser.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Service Account"))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Informational alert for service accounts "),
          (isServiceUser.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", {
                  class: "fa fa-info-circle",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createElementVNode("strong", null, "Service Account Roles:", -1 /* CACHED */),
                _createTextVNode(" These roles determine the API access permissions for this service account. The roles control what actions the service account can perform through the API. ", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_10, [
            (currentUserIsSystemAdmin.value || currentUserIsOrganizationAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["card text-white", [isBusinessUser.value ? 'bg-primary' : 'bg-secondary']])
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header" }, "Business User", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (isServiceUser.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Service accounts in this role have API access to:"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, "Users in this role have an access to individual dashboards and shared assets. They permissions include:")),
                        _createElementVNode("ul", null, [
                          (!isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, "Sign in to transparentChoice"))
                            : _createCommentVNode("v-if", true),
                          _cache[4] || (_cache[4] = _createElementVNode("li", null, "Access shared assets", -1 /* CACHED */)),
                          (!isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_17, "Use dashboard"))
                            : _createCommentVNode("v-if", true),
                          (isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_18, "Read-only API operations"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      (!isBusinessUser.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleAssignBusinessUserRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Assign Business User"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: handleRevokeBusinessUserRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Revoke Business User"))
                    ])
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true),
            (currentUserIsSystemAdmin.value || currentUserIsOrganizationAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["card text-white", [isWorkspaceUser.value ? 'bg-primary' : 'bg-secondary']])
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, "Workspace User", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (isServiceUser.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Service accounts in this role have API access to:"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "Users in this role have an access to workspaces and its portfolios. They permissions include:")),
                        _createElementVNode("ul", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("li", null, "Creating a new portfolios", -1 /* CACHED */)),
                          _cache[7] || (_cache[7] = _createElementVNode("li", null, "Managing projects", -1 /* CACHED */)),
                          _cache[8] || (_cache[8] = _createElementVNode("li", null, "Managing criteria", -1 /* CACHED */)),
                          (!isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, "Managing surveys"))
                            : _createCommentVNode("v-if", true),
                          (!isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, "Browsing results"))
                            : _createCommentVNode("v-if", true),
                          (isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_27, "Full workspace API operations"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (!isWorkspaceUser.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleAssignWorkspaceUserRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Assign Workspace User"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: handleRevokeWorkspaceUserRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Revoke Workspace User"))
                    ])
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true),
            (currentUserIsSystemAdmin.value || currentUserIsGlobalAdmin.value || currentUserIsOrganizationAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["card text-white", [isOrganizationAdmin.value ? 'bg-primary' : 'bg-secondary']])
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, "Organization Admin", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (isServiceUser.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Service accounts in this role have API access to:"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_33, "Users in this role have an access to admin panel and can manage within a single organizations. They permissions include:")),
                        _createElementVNode("ul", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("li", null, "Managing users", -1 /* CACHED */)),
                          _cache[11] || (_cache[11] = _createElementVNode("li", null, "Managing workspaces", -1 /* CACHED */)),
                          _cache[12] || (_cache[12] = _createElementVNode("li", null, "Importing portfolios", -1 /* CACHED */)),
                          (isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_34, "Organization-level API operations"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (!isOrganizationAdmin.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleAssignOrganizationAdminRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Assign Organization Admin"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: handleRevokeOrganizationAdminRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Revoke Organization Admin"))
                    ])
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true),
            (currentUserIsSystemAdmin.value || currentUserIsGlobalAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["card text-white", [isGlobalAdmin.value ? 'bg-primary' : 'bg-secondary']])
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header" }, "Global Admin", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        (isServiceUser.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Service accounts in this role have API access to:"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_40, "Users in this role have an access to admin panel and can set up organizations. They permissions include:")),
                        _createElementVNode("ul", null, [
                          _cache[14] || (_cache[14] = _createElementVNode("li", null, "Setting up a new organizations", -1 /* CACHED */)),
                          _cache[15] || (_cache[15] = _createElementVNode("li", null, "Assign global admins", -1 /* CACHED */)),
                          _cache[16] || (_cache[16] = _createElementVNode("li", null, "Assign organization admins", -1 /* CACHED */)),
                          (isServiceUser.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_41, "System-wide API operations"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      (!isGlobalAdmin.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleAssignGlobalAdminRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Assign Global Admin"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: handleRevokeGlobalAdminRoleCommandV1,
                            type: "button",
                            class: "btn btn-light text-ellipsis"
                          }, "Revoke Global Admin"))
                    ])
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : (!id.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailinput).value = $event)),
                type: "email",
                class: "form-control",
                placeholder: "Find user by email"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, emailinput.value]
              ]),
              _createElementVNode("div", { class: "input-group-append" }, [
                _createElementVNode("button", {
                  onClick: handleFindUser,
                  class: "btn btn-outline-secondary",
                  type: "button"
                }, "Find")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("h4", null, "Email '" + _toDisplayString(id.value) + "' not found", 1 /* TEXT */)
          ]))
  ]))
}
}

})